import module from './module.js'

// Components

// Routes

// Services


export default module.name



// WEBPACK FOOTER //
// ./src/viatico/index.js